var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"page404",attrs:{"src":"404_minions2.jpg","alt":"Logo Leblon Equities"}})])}]

export { render, staticRenderFns }